<template>
  <b-modal
    ref="modal-ticket-export-excel"
    id="modal-ticket-export-excel"
    hide-footer
    title="Xuất Excel danh sách phiếu hỗ trợ"
    :no-close-on-esc="isSubmitting('export')"
    :no-close-on-backdrop="isSubmitting('export')"
    :hide-header-close="isSubmitting('export')"
    @shown="getHistoryExportExcel()"
    @hide="onHide"
  >
    <b-row class="mb-4">
      <b-col cols="12">
        <b-form-group label="Danh sách cần xuất:">
          <b-form-radio-group v-model="selectedListExcel" :disabled="isProcessing">
            <b-form-radio value="filter">Theo bộ lọc</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </b-col>
      <b-col cols="12">
        <p class="text-muted font-italic mb-0">
          Xuất đúng theo bộ lọc đang áp dụng ở danh sách, tối đa
          {{ EXPORT_MAX_TICKET }} phiếu mỗi lần.
        </p>
      </b-col>
    </b-row>

    <div>
      <hr class="hr-text" data-content="Lịch sử xuất excel" style="font-weight: 600" />
      <b-table
        class="myTable"
        caption-top
        responsive
        bordered
        hover
        :fields="fieldHistory"
        :items="histories"
        show-empty
        empty-text="Chưa có phiên xuất nào"
      >
        <template v-slot:cell(actions)="row">
          <v-icon
            v-if="+row.item.processingStatus === PROCESSING_DOWNLOAD_STATUS.COMPLETED"
            small
            class="text-primary"
            title="Tải xuống"
            v-b-tooltip
            :disabled="isSubmitting('download-' + row.item.id)"
            @click="downloadExcel(row.item.id)"
            >mdi-download</v-icon
          >
          <div
            v-else-if="+row.item.processingStatus === PROCESSING_DOWNLOAD_STATUS.PROCESSING"
            class="d-flex align-items-center"
          >
            <b-progress height="20px" class="flex-grow-1">
              <b-progress-bar
                :value="row.item.process"
                :label="`${row.item.process}%`"
                animated
                variant="success"
              ></b-progress-bar>
            </b-progress>
            <v-icon
              small
              class="text-danger ml-2"
              title="Huỷ xuất file"
              v-b-tooltip
              :disabled="isSubmitting('cancel-' + row.item.id)"
              @click="cancelExport(row.item.id)"
              >mdi-close</v-icon
            >
          </div>
          <span v-else class="text-danger">Lỗi</span>
        </template>
      </b-table>
    </div>

    <SaveButton
      class="mr-3"
      :button-style="{
        fontWeight: '600',
        minWidth: '70px',
        whiteSpace: 'nowrap',
      }"
      :is-busy="isProcessing"
      type="button"
      @click="exportExcel"
    >
      <v-icon small class="text-white" v-b-tooltip>mdi-download</v-icon>
      <strong>Xuất Excel</strong>
    </SaveButton>

    <b-button
      style="width: 80px"
      variant="secondary"
      size="sm"
      :disabled="isSubmitting('export')"
      @click="$bvModal.hide('modal-ticket-export-excel')"
    >
      <strong>Đóng</strong>
    </b-button>
  </b-modal>
</template>

<script>
import ApiService from '@/core/services/api.service';
import fileDownload from '@/utils/file-download';
import { makeToastSuccess, makeToastFaile, handleError } from '@/utils/common';
import { PROCESSING_DOWNLOAD_STATUS } from '@/utils/enum';
import SaveButton from '@/view/components/common/SaveButton.vue';
import submitLock from '@/view/mixins/submit-lock.mixins';

const EXPORT_BASE = 'v2/tickets/export';
const POLL_INTERVAL_MS = 5000;
//  Bao nhiêu nhịp poll liên tiếp mà % KHÔNG nhúc nhích thì coi là phiên chết. 24 × 5s = 2 phút
//  — dài hơn hẳn thời gian ghi một lô 100 phiếu, nên không cắt nhầm phiên đang chạy chậm.
const STALL_TICKS = 24;
//  Khớp EXPORT_MAX_TICKET bên BE (ticket.service.js) — chỉ để hiện lời nhắc, BE vẫn là chỗ chặn thật.
const EXPORT_MAX_TICKET = 1000;

export default {
  components: { SaveButton },
  mixins: [submitLock],
  props: {
    apiParams: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      PROCESSING_DOWNLOAD_STATUS,
      EXPORT_MAX_TICKET,
      selectedListExcel: 'filter',
      histories: [],
      pollingIntervals: {},
      //  Số nhịp poll liên tiếp mà % đứng yên, theo từng id — xem `STALL_TICKS`.
      pollStalls: {},
      //  Phiên đã kết luận là CHẾT: id -> % dừng ở đó. Giữ NGOÀI `histories` vì mỗi lần nạp
      //  lại lịch sử là dựng row mới từ API, gắn cờ vào row thì mất.
      stalledIds: {},
      //  Modal dang mo hay khong - dung de chan polling mo coi, xem `startPolling`.
      isOpen: false,
      fieldHistory: [
        {
          key: 'name',
          label: 'Tên File',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '80%' },
          tdClass: 'text-center',
        },
        { key: 'actions', label: '', tdClass: 'text-center' },
      ],
    };
  },
  beforeDestroy() {
    //  `BModal.beforeDestroy` gán thẳng `isVisible = false`, KHÔNG phát `hide`, nên `onHide`
    //  không chạy. Không tự hạ cờ ở đây thì `getHistoryExportExcel` đang bay vẫn tạo
    //  được interval trên component đã huỷ, không còn ai `clearInterval`.
    this.isOpen = false;
    this.stopPolling();
  },
  computed: {
    /**
     * Khoá nút Xuất + ô chọn danh sách khi còn phiên chưa xong (Rule 11 mục 3b). Request tạo
     * phiên trả về gần như tức thì nên phải khoá theo BẢN GHI chưa xong, không chỉ theo
     * `isSubmitting('export')` — bằng không bấm tiếp là sinh phiên thứ hai chạy song song.
     *
     * CỐ Ý không khoá nút Đóng / ESC / backdrop theo cờ này: một phiên chết giữa chừng để lại
     * dòng PROCESSING vĩnh viễn, khoá theo nó thì lần sau mở modal là kẹt cứng không đóng được.
     */
    isProcessing() {
      return (
        this.isSubmitting('export') ||
        this.histories.some(
          (item) =>
            +item.processingStatus === PROCESSING_DOWNLOAD_STATUS.PROCESSING &&
            +item.process < 100 &&
            !item.stalled,
        )
      );
    },
  },
  methods: {
    showModal() {
      this.selectedListExcel = 'filter';
      this.isOpen = true;
      this.$refs['modal-ticket-export-excel'].show();
    },
    onHide() {
      this.isOpen = false;
      this.stopPolling();
    },
    exportExcel() {
      return this.withSubmitLock('export', () => this.doExportExcel());
    },
    async doExportExcel() {
      try {
        //  File ghi ở NỀN, response chỉ báo đã nhận việc. Tải lại ở bảng lịch sử bên dưới.
        const { data } = await ApiService.query(EXPORT_BASE, {
          params: this.apiParams,
        });
        makeToastSuccess(data.message);
      } catch (error) {
        handleError(error);
      } finally {
        //  await để khoá giữ tới khi histories có dòng mới, tránh nút mở lại quá sớm.
        await this.getHistoryExportExcel();
      }
    },
    async getHistoryExportExcel() {
      try {
        const { data } = await ApiService.query(`${EXPORT_BASE}/history`);
        if (!data.status) return;

        this.histories = await Promise.all(
          (data.data || [])
            .filter((item) => item.url)
            .map(async (item) => {
              let process = 100;

              //  Dùng `in` chứ không ép boolean: phiên chết ở 0% vẫn phải tính là chết.
              const stalled = item.id in this.stalledIds;
              if (stalled) process = this.stalledIds[item.id];

              if (!stalled && +item.processingStatus === PROCESSING_DOWNLOAD_STATUS.PROCESSING) {
                const progress = await this.getProcessDownload(item.id);
                process = progress ? progress.process : 0;
                //  `process = 100` mà trạng thái vẫn PROCESSING = phiên CHẾT (server restart,
                //  hoặc key Redis hết TTL 24h nên `getProcessDownload` mặc định 100). Poll tiếp
                //  thì stop → nạp lại → thấy PROCESSING → poll lại: vòng lặp không bao giờ dừng.
                if (+process < 100) this.startPolling(item.id);
              }

              return { ...item, name: item.url.split('/').pop(), process, stalled };
            }),
        );
      } catch (error) {
        handleError(error);
      }
    },
    async getProcessDownload(id) {
      try {
        //  `_t` để IE/proxy không trả bản cache — % đứng yên là lỗi khó đoán nhất ở đây.
        const { data } = await ApiService.query(`${EXPORT_BASE}/process`, {
          params: { id, _t: Date.now() },
        });
        return data.data;
      } catch (error) {
        return null;
      }
    },
    downloadExcel(id) {
      return this.withSubmitLock(`download-${id}`, () => this.doDownloadExcel(id));
    },
    async doDownloadExcel(id) {
      let response = null;
      try {
        response = await ApiService.query(`${EXPORT_BASE}/${id}/download`, {
          responseType: 'blob',
        });
      } catch (error) {
        makeToastFaile(await this.getErrorMessage(error));
        this.getHistoryExportExcel();
        return;
      }

      //  Tách khỏi try của request: `getFileName` NÉM khi thiếu Content-Disposition
      //  (file-download.js:50). Để chung một try thì BE đã stream xong và đánh dấu downloaded
      //  — dòng rụng khỏi lịch sử — mà người dùng chỉ thấy "Lỗi!".
      try {
        fileDownload.createFile(response.data, fileDownload.getFileName(response));
        makeToastSuccess('Tải xuống dữ liệu thành công');
      } catch (error) {
        makeToastFaile(error.message || 'Không đọc được tên file trả về');
      }
      //  Tải xong BE đánh dấu downloaded nên dòng này rụng khỏi lịch sử — nạp lại cho khớp.
      this.getHistoryExportExcel();
    },
    cancelExport(id) {
      return this.withSubmitLock(`cancel-${id}`, () => this.doCancelExport(id));
    },
    async doCancelExport(id) {
      try {
        //  `ApiService.delete` KHÔNG reject khi lỗi — nó tự toast rồi `return error`
        //  (`core/services/api.service.js:174`), khác `query`/`post`. Destructure thẳng
        //  `{ data }` thì gặp AxiosError ra `undefined` và `data.status` ném TypeError.
        const res = await ApiService.delete(`${EXPORT_BASE}/${id}/cancel`);
        if (!res || !res.data) return;
        if (res.data.status) makeToastSuccess(res.data.message);
      } catch (error) {
        handleError(error);
      } finally {
        this.stopPolling(id);
        this.getHistoryExportExcel();
      }
    },
    startPolling(id) {
      //  `getHistoryExportExcel` bất đồng bộ: đóng modal trước khi nó settle thì `onHide`
      //  gọi `stopPolling` lúc `pollingIntervals` còn rỗng, rồi interval mới được tạo sau
      //  đó và chạy ngầm mãi. Chốt theo cờ mở/đóng thay vì dựa vào thứ tự.
      if (!this.isOpen || this.pollingIntervals[id]) return;

      this.pollingIntervals[id] = setInterval(async () => {
        const progress = await this.getProcessDownload(id);
        if (!progress) return this.stopPolling(id);

        const previous = this.histories.find((item) => item.id === id);
        const isStuck = previous && +previous.process === +progress.process;
        this.pollStalls[id] = isStuck ? (this.pollStalls[id] || 0) + 1 : 0;

        this.histories = this.histories.map((item) =>
          item.id === id ? { ...item, process: progress.process } : item,
        );

        //  Nạp lại khi đã xong HOẶC khi BE báo lỗi: cả hai đều đổi processingStatus, mà cột
        //  thao tác vẽ theo processingStatus chứ không theo %.
        if (
          +progress.process === 100 ||
          +progress.processingStatus === PROCESSING_DOWNLOAD_STATUS.ERROR
        ) {
          this.stopPolling(id);
          this.getHistoryExportExcel();
          return;
        }

        //  Server chết giữa lúc build thì processingStatus kẹt PROCESSING và key Redis giữ
        //  nguyên % dở dang suốt 24h: không bao giờ tới 100 cũng không bao giờ thành ERROR,
        //  nên vòng poll chạy mãi và `isProcessing` khoá cứng nút Xuất. Đứng yên quá lâu thì
        //  đánh dấu `stalled` để thoát cả hai. Người dùng vẫn bấm được nút Huỷ ở dòng đó.
        if (this.pollStalls[id] >= STALL_TICKS) {
          this.$set(this.stalledIds, id, +progress.process);
          this.stopPolling(id);
          this.histories = this.histories.map((item) =>
            item.id === id ? { ...item, stalled: true } : item,
          );
        }
      }, POLL_INTERVAL_MS);
    },
    //  Không truyền id thì dọn toàn bộ — dùng khi đóng modal hoặc component bị huỷ.
    stopPolling(id) {
      const ids = id ? [id] : Object.keys(this.pollingIntervals);

      ids.forEach((key) => {
        clearInterval(this.pollingIntervals[key]);
        delete this.pollingIntervals[key];
        delete this.pollStalls[key];
      });
    },
    async getErrorMessage(error) {
      if (!error.response) return 'Lỗi!';

      const data = error.response.data;
      //  request blob thì body lỗi cũng là Blob, phải đọc text rồi parse mới ra message
      if (data instanceof Blob) {
        try {
          const { message } = JSON.parse(await data.text());
          return message || 'Lỗi!';
        } catch (parseError) {
          return 'Lỗi!';
        }
      }

      return data.message || 'Lỗi!';
    },
  },
};
</script>

<style scoped>
div /deep/ .modal-backdrop {
  opacity: 0.5;
}
</style>
